import React from 'react'
import Lottie from 'lottie-react';
import HeartLoop from './JSONFile/HeartLoop.json'; // Renamed the imported JSON to avoid conflict

const LodingLottie = ({ClassCss}) => {
  return (
      <Lottie
        className={ClassCss}
        animationData={HeartLoop}
        loop={true}
      />
  );
}

export default LodingLottie;
